let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("In3T2")).then(() => parcelRequire('3XrVw'));